import { createContext } from 'react'
import type { Coords, GeolocationPermission } from '@/lib/geolocation'

interface UserLocationContextValue {
  coords: Coords | null
  permission: GeolocationPermission
  isRequesting: boolean
  requestLocation: () => Promise<void>
}

export const UserLocationContext = createContext<UserLocationContextValue | null>(null)
